function getCourses(state) {
  return state.courses;
}

function getQuizzesByCourse(state) {
  return (courseId) => {
    return state.quizzesByCourse[courseId] || null;
  };
}

function getConfigurations(state) {
  return state.configurations;
}

function getSelectedInstanceId(state) {
  return state.selectedInstanceId;
}

function getCategories(state) {
  return state.categories;
}

export default {
  getCourses,
  getQuizzesByCourse,
  getConfigurations,
  getSelectedInstanceId,
  getCategories,
};
